import { render, staticRenderFns } from "./Delivered_new.vue?vue&type=template&id=2f9cff80&scoped=true"
import script from "./Delivered_new.vue?vue&type=script&lang=js"
export * from "./Delivered_new.vue?vue&type=script&lang=js"
import style0 from "./Delivered_new.vue?vue&type=style&index=0&id=2f9cff80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9cff80",
  null
  
)

export default component.exports